import React from "react";
import i18next from "src/i18n/config";
import PaymentService from "src/services/paymentService";

import { getSettings } from "@services/configService";
import { showErrorToast } from "@shared/toasts/Toasts";
import { Stripe } from "@stripe/stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";

import { getBillingCard } from "../api";

export function useAccountBillingCard() {
    const [billingCard, setBillingCard] = React.useState<API.BillingCard | null>(null);
    const [stripePromise, setStripePromise] = React.useState<PromiseLike<Stripe | null> | Stripe | null>(null);
    const [isLoading, setIsLoading] = React.useState(true);

    const { features } = getSettings();
    const isStripeEnabled = features.stripeEnabled;

    React.useEffect(() => {
        const loadCardData = async () => {
            try {
                const _billingCard = await getBillingCard();
                setBillingCard(_billingCard);
                if (_billingCard !== null) {
                    const promiseData = await PaymentService.getStripePromise(loadStripe);
                    setStripePromise(promiseData as PromiseLike<Stripe | null> | Stripe | null);
                }
            } catch (_error) {
                showErrorToast(i18next.t("pages:settingsPage.toast.billingCardLoadError"));
            } finally {
                setIsLoading(false);
            }
        };
        if (isStripeEnabled) {
            void loadCardData();
        } else {
            setIsLoading(false);
        }
    }, [isStripeEnabled]);

    return {
        billingCard,
        stripePromise,
        isStripeEnabled,
        isLoading,
    };
}
